import React from "react";
import AboutUs from "../components/AboutUs/AboutUs";
import Carousel from "../components/Carousel/Carousel";
import Founders from "../components/Founders/Founders";
import Gallery from "../components/Gallery/Gallery";
import Princibles from "../components/Principles/Princibles";
// import Purpose from "../components/Purpose/Purpose";
import Events from "../components/Events/Events";
import Register from "../components/Register/Register";

import SocialMediaIcons from "../components/SocialMediaIcons/SocialMediaIcons";
const Home = () => {
  return (
    <>
      <div id="home" />
      <div className="sm:hidden">
        <SocialMediaIcons top={"20%"} m={true} />
      </div>
      <div className="hidden 2xl:block">
        <SocialMediaIcons top={"25%"} m={false} />
      </div>
      <div className="hidden lg:block 2xl:hidden">
        <SocialMediaIcons top={"15%"} m={false} />
      </div>
      <div className="hidden sm:block lg:hidden">
        <SocialMediaIcons top={"10%"} m={true} />
      </div>
      <Carousel />
      <AboutUs />
      {/* <Purpose /> */}
      <Princibles />
      <Founders />
      <Gallery />
      <div id="Reg" />
      <Register />
      <div id="Evnt" />
      <Events />
    </>
  );
};

export default Home;
